import { Group, Button } from '@mantine/core';
import { useAiCoachAssistantStore } from 'store/aiCoachAssistantStore';
import { IconButton } from 'components/IconButton/IconButton';

const QUICK_ACTIONS = [
  {
    label: 'Check meetings',
    icon: 'tabler:calendar-event',
    prompt:
      'Check if this user has any scheduled meetings coming up and summarize them',
  },
  {
    label: 'Summarize last session',
    icon: 'tabler:notes',
    prompt: 'Give me a summary of the last coaching session with this user',
  },
  {
    label: 'Disengagement check',
    icon: 'tabler:alert-triangle',
    prompt:
      "Analyze this user's recent activity and identify any signs of disengagement",
  },
  {
    label: 'Draft follow-up',
    icon: 'tabler:message-forward',
    prompt:
      'Draft a follow-up message for this user based on our recent interactions',
  },
  {
    label: 'Last discussion',
    icon: 'tabler:message-chatbot',
    prompt: 'What was the last thing discussed with this user in chat?',
  },
  {
    label: 'Progress Pulse',
    icon: 'tabler:activity',
    prompt:
      "Analyze this user's Progress Pulse history and summarize symptom trends, stating the period the data covers",
  },
];

interface QuickActionsProps {
  compact?: boolean;
}

export const QuickActions = ({ compact }: QuickActionsProps) => {
  const setPrefillText = useAiCoachAssistantStore((s) => s.setPrefillText);
  const isSubmitInProgress = useAiCoachAssistantStore(
    (s) => s.isSubmitInProgress
  );

  return (
    <Group gap="xs" px="md" py="xs">
      {QUICK_ACTIONS.map((action) =>
        compact ? (
          <IconButton
            key={action.label}
            tooltip={action.label}
            icon={action.icon}
            disabled={isSubmitInProgress}
            onClick={() => setPrefillText(action.prompt)}
          />
        ) : (
          <Button
            key={action.label}
            variant="light"
            size="compact-sm"
            color="teal"
            styles={{ label: { color: 'black' } }}
            disabled={isSubmitInProgress}
            onClick={() => setPrefillText(action.prompt)}>
            {action.label}
          </Button>
        )
      )}
    </Group>
  );
};
